import { useCallback, useMemo } from "react";
import { useCurrentProjectFocusesId } from "@radarly/core/project/use-cases";
import { Card } from "@radarly/models/cards";
import { setCardClause, setCardPeriod } from "@radarly/models/cards/editor";
import { Clause } from "@radarly/models/clause";
import {
  getClauseFromCard,
  getDateFromClause,
} from "@radarly/models/clause/getter";
import { useDraftClause } from "../../clause/draft";

export function useCardEditor(card: Card, setCard: (card: Card) => void) {
  const clause = getClauseFromCard(card);
  const projectFocuses = useCurrentProjectFocusesId();
  const handleSetCardClause = useCallback(
    (clause: Clause) => {
      setCard(setCardClause(card, clause, projectFocuses));
    },
    [card, setCard, projectFocuses]
  );
  const handleSetCardPeriod = (period) => {
    setCard(setCardPeriod(card, period));
  };

  const {
    draft,
    hasDraft,
    onSubmit,
    onSubmitDraft,
    onCancelDraft,
    setDraft,
    onClose,
    hasClause,
  } = useDraftClause(clause, handleSetCardClause);
  const period = useMemo(() => {
    return getDateFromClause(clause);
  }, [clause]);
  return {
    cardDraftClause: draft || clause,
    hasCardDraftClause: hasDraft,
    onSubmitCardClause: onSubmit,
    onSubmitCardDraftClause: onSubmitDraft,
    onCancelCardDraftClause: onCancelDraft,
    setCardDraftClause: setDraft,
    onClosePanelEditor: onClose,
    hasCardClause: hasClause,
    setCardPeriod: handleSetCardPeriod,
    period,
  };
}
